import { Box, Stack, Typography } from "@mui/material";
import ReactPlayer from "react-player";

type Props = {
  currentBlock: any;
};

const VideoField = ({ currentBlock }: Props) => {
  const label = currentBlock?.label;
  const signedResourceUrl = currentBlock?.signedResourceUrl;

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItem: "center",
        }}
      >
        <Stack gap={0.5}>
          {label && (
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: "regular",
                color: "text.primary",
              }}
            >
              {label}
            </Typography>
          )}
          {signedResourceUrl && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                maxHeight: "400px",
                maxWidth: "400px",
                objectFit: "contain",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <ReactPlayer
                controls
                height="100%"
                width="100%"
                url={signedResourceUrl}
              />
            </Box>
          )}
        </Stack>
      </Box>
    </>
  );
};
export default VideoField;
